import React, { useState } from 'react';
import styled from 'styled-components';
import { useLang } from '../../context/LangContext';
import { isShoppingMode } from '../../config/appMode';
import CenteredLayout from '../../layout/CenteredLayout';
import MainLayout from '../../layout/MainLayout';
import ProjectAppbar from '../../customComponents/ProjectAppbar';
import TabBar from '../../components/TabBar';
import WonAuctions from './WonAuctions';
import BidHistory from './BidHistory';

const AuctionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top:4px;
  /* margin-top: 16px; */
`;

// 다국어 텍스트
const auctionTexts = {
  ko: {
    title: isShoppingMode() ? '구매' : '경매',
    wonAuctions: isShoppingMode() ? '나의 구매 내역' : '나의 낙찰 내역',
    bidHistory: isShoppingMode() ? '나의 구매 내역' : '나의 입찰 내역'
  },
  en: {
    title: isShoppingMode() ? 'Purchase' : 'Auction',
    wonAuctions: isShoppingMode() ? 'My Purchases' : 'My Won Auctions',
    bidHistory: isShoppingMode() ? 'My Purchases' : 'My Bid History'
  }
};

function Auction() {
  const { lang } = useLang();
  const texts = auctionTexts[lang];
  
  // 탭 상태 관리
  const [activeTab, setActiveTab] = useState(0);
  
  // 탭 목록
  const tabs = [texts.bidHistory, texts.wonAuctions];
  
  // 탭 변경 핸들러
  const handleTabChange = (tabIndex: number) => {
    setActiveTab(tabIndex);
  };
  
  // 현재 탭에 따른 컴포넌트 렌더링
  const renderTabContent = () => {
    switch (activeTab) {
      case 0:
        return <BidHistory />;
      case 1:
        return <WonAuctions />;
      default:
        return <BidHistory />;
    }
  };

  return (
    <MainLayout currentPage="auction">
      <CenteredLayout>
        <ProjectAppbar 
          currentPage="auction"
          title={texts.title}
        />
        <AuctionContainer>
          {!isShoppingMode() && (
            <TabBar 
              tabs={tabs}
              activeTab={activeTab}
              onTabChange={handleTabChange}
            />
          )}
          <ContentContainer>
            {isShoppingMode() ? <BidHistory /> : renderTabContent()}
          </ContentContainer>
        </AuctionContainer>
      </CenteredLayout>
    </MainLayout>
  );
}

export default Auction;
